import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { TimeSchedule } from '@/models/service'

interface Props {
  selectedDays: number[]
  timeSchedules: TimeSchedule[]
}

const Message = (props: PropsWithChildren) => (
  <div className="text-pretty">{props.children}</div>
)

export function TimeScheduleDialogMessage(props: Props) {
  const { t } = useTranslation()

  if (props.selectedDays.length === 0) {
    return <Message>{t('timeSchedulesDialog.errors.noDays')}</Message>
  }

  if (props.timeSchedules.length === 0) {
    return <Message>{t('timeSchedulesDialog.errors.noSchedules')}</Message>
  }

  return null
}
